/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* Media data for VAST tags in StackAdapt campaign ads
*/
export class V3StackAdaptVastMediaData {
    /**
    * Duration of the media in seconds
    */
    'duration'?: number;
    /**
    * Height of the media in pixels
    */
    'height'?: number;
    /**
    * Width of the media in pixels
    */
    'width'?: number;
    /**
    * Bitrate of the media in mbps
    */
    'bitrate'?: number;
    /**
    * File type of the media. Examples include 'video/mp4', 'video/webm', etc.
    */
    'fileType'?: string;
    /**
    * URL for media uploaded to StackAdapt's AWS S3 server
    */
    's3Url'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "duration",
            "baseName": "duration",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "height",
            "baseName": "height",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "width",
            "baseName": "width",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "bitrate",
            "baseName": "bitrate",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "fileType",
            "baseName": "fileType",
            "type": "string",
            "format": ""
        },
        {
            "name": "s3Url",
            "baseName": "s3Url",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3StackAdaptVastMediaData.attributeTypeMap;
    }

    public constructor() {
    }
}

